import styled from 'styled-components';
import { Select } from '../Select/Select';
export var StyledReadOnlySelect = /*#__PURE__*/styled(Select).withConfig({
  displayName: "StyledReadOnlySelect",
  componentId: "c11n-8-111-1__sc-219df2-0"
})([""]);